<template>
  <v-row align="center">
    <v-col
      cols="12"
      :xl="gridSpacing.xl"
      :lg="gridSpacing.lg"
      :md="gridSpacing.md"
      :sm="gridSpacing.sm"
    >
      <chart-card
        :title="title"
        :subtitle="subtitle"
        :is-loaded="isLoaded"
        :has-error="hasError"
        :theme-data="data"
        :error-msg="errorMsg"
        :error-empty="errorEmpty"
        :color="color"
      />
    </v-col>
    <v-col
      cols="12"
      :xl="gridSpacing.xl"
      :lg="gridSpacing.lg"
      :md="gridSpacing.md"
      :sm="gridSpacing.sm"
    >
      <results-by-universes
        :request="request"
        :is-admin="isAdmin"
        :error-msg="errorMsg"
        :error-empty="errorEmpty"
        :color="color"
        @set-error="$emit('set-error', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import ChartCard from '../../charts/ChartCard.vue'
  import ResultsByUniverses from '../../tables/ResultsByUniverses.vue'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'GlobalUniverse',

    /* Sous-composants utilisés par ce composant */
    components: {
      ChartCard,
      ResultsByUniverses,
    },

    /* Paramètres */
    props: {
      request: {
        type: String,
        default: '',
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
      errorMsg: {
        type: String,
        default: 'Un problème est survenu.',
      },
      errorEmpty: {
        type: Object,
        default: function () {
          return {
            msg: 'Un problème est survenu.',
            icon: 'mdi-alert-rhombus-outline',
            color: 'error',
          }
        },
      },
      color: {
        type: String,
        default: 'primary',
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        gridSpacing: {
          xl: '6',
          lg: '6',
          md: '6',
          sm: '12',
          xs: '12',
        },
        title: 'Évolution des univers',
        subtitle: '',
        isLoaded: false,
        hasError: false,
        data: {},
      }
    },

    /* Variables surveillées : traitement si modification de sa valeur */
    watch: {
      request: function () {
        this.isLoaded = false
        this.fetchAllData()
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchAllData()
    },

    /* Fonctions internes */
    methods: {
      fetchAllData: function () {
        this.lineChartData('Universes')
      },

      // Génération des couleurs pour les courbes
      getColors: function (lvlCount) {
        const colors = []
        const borderColors = []
        this.$chartColors.forEach((item, i) => {
          if (i < lvlCount) {
            colors.push('rgba(' + item.r + ',' + item.g + ',' + item.b + ', 0.4)')
            borderColors.push('rgba(' + item.r + ',' + item.g + ',' + item.b + ', 1)')
          }
        })
        return { colors: colors, borderColors: borderColors }
        /* const colors = [lvlCount]
        const borderColors = [lvlCount]
        let r = 0
        let g = 0
        let b = 0
        for (let i = 0; i < lvlCount; i++) {
          r = Math.floor(Math.random() * 256)
          g = Math.floor(Math.random() * 256)
          b = Math.floor(Math.random() * 256)
          colors[i] = 'rgba(' + r + ',' + g + ',' + b + ', 0.4)'
          borderColors[i] = 'rgba(' + r + ',' + g + ',' + b + ', 1)'
        }
        return { colors: colors, borderColors: borderColors } */
      },

      // Génération des données au format Chart.js
      lineChartData: function (dataType) {
        this.$Auth.httpRequest(
          'get',
          'api/dashboard/evolution' + dataType + this.request,
        ).then(datas => {
          let labelsCustom = []
          const datasetsCustom = []
          let min = 0
          let max = 0
          const colors = this.getColors(Object.keys(datas.data).length)
          let k = 0
          const date = []

          Object.keys(datas.data).forEach(function (key) {
            const score = []

            Object.keys(datas.data[key]).forEach(function (obj) {
              if (
                date.length !== 0 &&
                datas.data[key][obj].monthNumber - 1 !== date[date.length - 1]
              ) {
                const diff =
                  datas.data[key][obj].weekNumber - date[date.length - 1]

                for (let i = 0; i <= diff; i++) {
                  score.push(null)
                  date.push(null)
                }
              }

              const formattedDate = datas.data[key][obj].monthNumber + '/' + datas.data[key][obj].yearNumber
              const index = date.findIndex(x => x === formattedDate)

              score.push(datas.data[key][obj].score)
              if (index === -1) {
                date.push(formattedDate)
              }

              if (min === 0) {
                min = datas.data[key][obj].monthNumber
              }
              if (max < datas.data[key][obj].monthNumber) {
                max = datas.data[key][obj].monthNumber
              }
            })

            //  on assigne au label custom les dates;
            labelsCustom = date

            datasetsCustom.push({
              label: key,
              fill: false,
              lineTension: 0.1,
              backgroundColor: colors.colors[k],
              borderColor: colors.borderColors[k],
              borderCapStyle: 'butt',
              borderJoinStyle: 'miter',
              data: score,
            })

            k++
          })
          this.isLoaded = true
          this.data = {
            labels: labelsCustom,
            datasets: datasetsCustom,
          }
          this.hasError = false
        }).catch((error) => {
          if (this.isAdmin) {
            // console.log('Error in ' + this.$options.name + ' : ', error)
          }
          this.hasError = true
          this.$emit('set-error', error)
        })
      },

    },
  }
</script>
